module.exports = __webpack_public_path__ + "img/knife.be5030ca.webp";